var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3335 2.66634C3.15668 2.66634 2.98712 2.73658 2.86209 2.8616C2.73707 2.98663 2.66683 3.1562 2.66683 3.33301V12.6663C2.66683 12.8432 2.73707 13.0127 2.86209 13.1377C2.98712 13.2628 3.15669 13.333 3.3335 13.333H6.00016C6.36835 13.333 6.66683 13.6315 6.66683 13.9997C6.66683 14.3679 6.36835 14.6663 6.00016 14.6663H3.3335C2.80306 14.6663 2.29435 14.4556 1.91928 14.0806C1.54421 13.7055 1.3335 13.1968 1.3335 12.6663V3.33301C1.3335 2.80257 1.54421 2.29387 1.91928 1.91879C2.29436 1.54372 2.80306 1.33301 3.3335 1.33301H6.00016C6.36835 1.33301 6.66683 1.63148 6.66683 1.99967C6.66683 2.36786 6.36835 2.66634 6.00016 2.66634H3.3335Z",
    fill: "#16192C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1953 4.19526C10.4556 3.93491 10.8777 3.93491 11.1381 4.19526L14.4714 7.5286C14.7318 7.78894 14.7318 8.21106 14.4714 8.4714L11.1381 11.8047C10.8777 12.0651 10.4556 12.0651 10.1953 11.8047C9.93491 11.5444 9.93491 11.1223 10.1953 10.8619L13.0572 8L10.1953 5.13807C9.93491 4.87772 9.93491 4.45561 10.1953 4.19526Z",
    fill: "#16192C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3335 7.99967C5.3335 7.63148 5.63197 7.33301 6.00016 7.33301H14.0002C14.3684 7.33301 14.6668 7.63148 14.6668 7.99967C14.6668 8.36786 14.3684 8.66634 14.0002 8.66634H6.00016C5.63197 8.66634 5.3335 8.36786 5.3335 7.99967Z",
    fill: "#16192C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.4de13ba903da27d46bc7c4368e1c22c6.svg";
export { ForwardRef as ReactComponent };